/* =========================================================
   MNR OFFER PAGE v3.1  |  assets/mnr-offer.js
   v3.1: faster checkout (skips cart clear when empty, discount via
   ?discount= on checkout, optional cart-permalink mode, loading text)
   Gallery slider (no Swiper needed), tier switching,
   accordions, and direct add-to-cart -> checkout.
   Works in the Shopify theme editor (re-inits on section load).
   ========================================================= */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.__mnrInit) return;
    root.__mnrInit = true;

    var track = root.querySelector('[data-mnr-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-mnr-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-mnr-thumb]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-mnr-dot]'));
    var tiers = Array.prototype.slice.call(root.querySelectorAll('[data-mnr-tier]'));
    var firstPerk = root.querySelector('[data-mnr-first-perk]');
    var cta = root.querySelector('[data-mnr-cta]');
    var buyOnces = Array.prototype.slice.call(root.querySelectorAll('[data-mnr-buyonce]'));
    var errEl = root.querySelector('[data-mnr-error]');
    var cfg = {};
    var cfgEl = root.querySelector('[data-mnr-config]');
    try { cfg = JSON.parse(cfgEl ? cfgEl.textContent : '{}'); } catch (e) {}

    /* ---------- gallery ---------- */
    function visibleSlides() { return slides.filter(function (s) { return !s.hidden; }); }

    function setActive(realIdx) {
      thumbs.forEach(function (t) { t.classList.toggle('is-active', +t.getAttribute('data-mnr-thumb') === realIdx); });
      dots.forEach(function (d) { d.classList.toggle('is-active', +d.getAttribute('data-mnr-dot') === realIdx); });
    }

    function goTo(realIdx, instant) {
      if (!track) return;
      var vis = visibleSlides();
      var pos = vis.findIndex(function (s) { return +s.getAttribute('data-mnr-slide') === realIdx; });
      if (pos < 0) pos = 0;
      var prev = track.style.scrollBehavior;
      if (instant) track.style.scrollBehavior = 'auto';
      track.scrollTo({ left: pos * track.clientWidth });
      if (instant) setTimeout(function () { track.style.scrollBehavior = prev; }, 30);
      setActive(+vis[pos].getAttribute('data-mnr-slide'));
    }

    function currentPos() {
      if (!track || !track.clientWidth) return 0;
      return Math.round(track.scrollLeft / track.clientWidth);
    }

    if (track) {
      var raf = null;
      track.addEventListener('scroll', function () {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var vis = visibleSlides();
          var s = vis[Math.min(currentPos(), vis.length - 1)];
          if (s) setActive(+s.getAttribute('data-mnr-slide'));
        });
      }, { passive: true });

      /* desktop mouse drag (touch uses native swipe) */
      var startX = 0, startLeft = 0, dragging = false, moved = false;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        dragging = true; moved = false; startX = e.clientX; startLeft = track.scrollLeft;
        track.classList.add('is-dragging');
        track.setPointerCapture(e.pointerId);
      });
      track.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 3) moved = true;
        track.scrollLeft = startLeft - dx;
      });
      function endDrag(e) {
        if (!dragging) return;
        dragging = false;
        track.classList.remove('is-dragging');
        var dx = e.clientX - startX;
        var vis = visibleSlides();
        var startPos = Math.round(startLeft / track.clientWidth);
        var pos = startPos;
        if (moved && Math.abs(dx) > 40) pos = dx < 0 ? startPos + 1 : startPos - 1;
        pos = Math.max(0, Math.min(vis.length - 1, pos));
        goTo(+vis[pos].getAttribute('data-mnr-slide'));
      }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);

      window.addEventListener('resize', function () {
        var vis = visibleSlides();
        var active = root.querySelector('[data-mnr-dot].is-active');
        goTo(active ? +active.getAttribute('data-mnr-dot') : +(vis[0] && vis[0].getAttribute('data-mnr-slide')), true);
      });
    }

    thumbs.concat(dots).forEach(function (b) {
      b.addEventListener('click', function () {
        goTo(+(b.getAttribute('data-mnr-thumb') || b.getAttribute('data-mnr-dot')));
      });
    });

    /* show/hide slides per tier (image block setting "Show on tiers") */
    function filterGallery(tierNum) {
      [slides, thumbs, dots].forEach(function (list) {
        list.forEach(function (el) {
          var showOn = (el.getAttribute('data-show-on') || '').replace(/\s/g, '');
          el.hidden = showOn ? showOn.split(',').indexOf(String(tierNum)) === -1 : false;
        });
      });
      var vis = visibleSlides();
      if (vis.length) goTo(+vis[0].getAttribute('data-mnr-slide'), true);
    }

    /* ---------- tiers ---------- */
    function selectTier(t) {
      tiers.forEach(function (x) { x.classList.remove('sel'); x.setAttribute('aria-checked', 'false'); });
      t.classList.add('sel');
      t.setAttribute('aria-checked', 'true');
      var perk = t.getAttribute('data-first-perk') || '';
      if (firstPerk) {
        firstPerk.textContent = perk;
        firstPerk.hidden = !perk;
      }
      filterGallery(t.getAttribute('data-tier-num'));
    }
    tiers.forEach(function (t) {
      t.addEventListener('click', function () { selectTier(t); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectTier(t); }
      });
    });
    var initial = root.querySelector('[data-mnr-tier].sel') || tiers[0];
    if (initial) selectTier(initial);

    /* ---------- accordions ---------- */
    root.querySelectorAll('[data-mnr-acc]').forEach(function (h) {
      h.addEventListener('click', function () {
        var item = h.closest('.mnr-acc__item');
        var open = item.classList.toggle('is-open');
        h.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    /* ---------- cart ---------- */
    var JSONH = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
    function post(url, body) {
      return fetch(url, { method: 'POST', headers: JSONH, body: body ? JSON.stringify(body) : undefined })
        .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Cart error'); }); return r.json(); });
    }
    function giftItems() {
      return (cfg.gifts || []).filter(Boolean).map(function (id) { return { id: +id, quantity: 1 }; });
    }
    function go(discount) {
      var url;
      if (cfg.redirect === 'cart') {
        url = '/cart';
        if (discount) url = '/discount/' + encodeURIComponent(discount) + '?redirect=' + encodeURIComponent(url);
      } else {
        /* Straight to checkout; ?discount= applies the code there without the extra /discount redirect */
        url = '/checkout' + (discount ? '?discount=' + encodeURIComponent(discount) : '');
      }
      window.location.href = url;
    }

    /* ---- speed: know whether the cart is already empty, so we can skip /cart/clear.js ---- */
    var knownCount = null; /* null = unknown -> clear to be safe */
    function refreshCount() {
      knownCount = null;
      if (!cfg.clearCart) return;
      fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) { if (c && typeof c.item_count === 'number') knownCount = c.item_count; })
        .catch(function () {});
    }
    /* Check in the background once the page is idle (doesn't slow the page down) */
    (window.requestIdleCallback || function (fn) { setTimeout(fn, 1200); })(refreshCount);

    /* ---- speed: cart permalink (one hop straight to checkout, no cart requests) ---- */
    function permalink(items, discount) {
      var parts = items.map(function (i) { return i.id + ':' + i.quantity; });
      return '/cart/' + parts.join(',') + (discount ? '?discount=' + encodeURIComponent(discount) : '');
    }
    function canUsePermalink(items) {
      if (!cfg.fastLinks) return false;
      if (cfg.redirect !== 'checkout' || !cfg.clearCart) return false;
      /* Subscriptions keep the normal route so the selling plan is attached reliably */
      return !items.some(function (i) { return i.selling_plan; });
    }

    /* ---- "add to cart and stay" mode ---- */
    var DRAWER_GUESSES = [
      '[data-cart-drawer-toggle]', '[data-drawer-toggle*="cart" i]', '[data-action="open-drawer"][data-drawer-id*="cart" i]',
      '[aria-controls*="cart" i]', 'cart-drawer-toggle', '.js-cart-drawer-toggle', '.header__cart-toggle',
      'header a[href$="/cart"]', 'a.header__icon--cart', '#cart-icon-bubble'
    ];
    function updateCounts(count) {
      document.querySelectorAll('[data-cart-count], .cart-count, .cart-count-bubble span:first-child, .header__cart-count, [data-header-cart-count], .js-cart-count')
        .forEach(function (el) { el.textContent = count; if (count > 0) el.removeAttribute('hidden'); });
    }
    function openDrawer() {
      var el = null;
      if (cfg.cartTrigger) { try { el = document.querySelector(cfg.cartTrigger); } catch (e) {} }
      if (!el) {
        for (var i = 0; i < DRAWER_GUESSES.length && !el; i++) {
          try { el = document.querySelector(DRAWER_GUESSES[i]); } catch (e) {}
        }
      }
      if (el) el.click();
    }
    function stay(btn, discount) {
      var pre = discount ? fetch('/discount/' + encodeURIComponent(discount), { credentials: 'same-origin' }).catch(function () {}) : Promise.resolve();
      return pre.then(function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          updateCounts(cart.item_count);
          ['cart:refresh', 'cart:updated', 'cart:change', 'theme:cart:change'].forEach(function (n) {
            document.dispatchEvent(new CustomEvent(n, { bubbles: true, detail: { cart: cart } }));
            document.documentElement.dispatchEvent(new CustomEvent(n, { bubbles: true, detail: { cart: cart } }));
          });
          openDrawer();
          reset(btn);
          if (cfg.addedText) {
            var original = btn.innerHTML;
            btn.textContent = cfg.addedText;
            btn.classList.add('is-added');
            setTimeout(function () { btn.innerHTML = original; btn.classList.remove('is-added'); }, 2200);
          }
        });
    }

    function showError(msg) {
      if (!errEl) return;
      errEl.textContent = msg || 'Something went wrong. Please try again.';
      errEl.classList.add('is-visible');
    }
    function reset(btn) {
      if (!btn) return;
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-busy');
      if (btn.__mnrText != null) { btn.textContent = btn.__mnrText; btn.__mnrText = null; }
    }
    function loading(btn) {
      btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true');
      /* Instant feedback so shoppers don't tap twice or bounce */
      if (cfg.loadingText && cfg.redirect !== 'drawer') {
        btn.__mnrText = btn.textContent;
        btn.textContent = cfg.loadingText;
      }
    }
    function buy(btn, items, discount) {
      if (btn.classList.contains('is-loading')) return;
      if (errEl) errEl.classList.remove('is-visible');
      loading(btn);

      /* Fastest: one link straight to checkout (one-time purchases only) */
      if (canUsePermalink(items)) {
        knownCount = null;
        window.location.href = permalink(items, discount);
        return;
      }

      /* Skip emptying the cart when we already know it's empty */
      var needClear = cfg.clearCart && knownCount !== 0;
      var chain = needClear ? post('/cart/clear.js') : Promise.resolve();
      chain.then(function () { return post('/cart/add.js', { items: items }); })
        .then(function () {
          knownCount = null; /* cart now has items; re-check before the next click */
          return cfg.redirect === 'drawer' ? stay(btn, discount) : go(discount);
        })
        .catch(function (err) {
          knownCount = null;
          reset(btn);
          showError(cfg.errorText || err.message);
          console.error('[mnr-offer] add failed', err);
        });
    }

    if (cta) cta.addEventListener('click', function (e) {
      e.preventDefault();
      var sel = root.querySelector('[data-mnr-tier].sel') || tiers[0];
      if (!sel) return;
      var vid = parseInt(sel.getAttribute('data-variant-id'), 10);
      if (!vid) { showError('Add a variant ID to this offer in the theme editor.'); return; }
      var qty = parseInt(sel.getAttribute('data-qty'), 10) || 1;
      var plan = parseInt(sel.getAttribute('data-selling-plan'), 10);
      var main = { id: vid, quantity: qty };
      if (plan) main.selling_plan = plan;
      var items = [main].concat(sel.getAttribute('data-gifts') === 'true' ? giftItems() : []);
      buy(cta, items, sel.getAttribute('data-discount') || '');
    });

    buyOnces.forEach(function (bo) {
      bo.addEventListener('click', function (e) {
        e.preventDefault();
        var vid = parseInt(bo.getAttribute('data-variant-id'), 10);
        if (!vid) { showError('Add a variant ID to the "Buy once link" block in the theme editor.'); return; }
        buy(bo, [{ id: vid, quantity: parseInt(bo.getAttribute('data-qty'), 10) || 1 }], '');
      });
    });

    /* Back button from checkout: restore buttons and re-check the cart (it now has items) */
    window.addEventListener('pageshow', function (e) {
      reset(cta); buyOnces.forEach(reset);
      if (e.persisted) refreshCount();
    });

    /* ---------- video cards -> popup player ---------- */
    var modal = root.querySelector('[data-mnr-vmodal]');
    if (modal) {
      var vbody = modal.querySelector('[data-mnr-vbody]');
      var lastFocus = null;
      function closeVideo() {
        var v = vbody.querySelector('video');
        if (v) { try { v.pause(); } catch (e) {} }
        vbody.innerHTML = '';
        modal.hidden = true;
        document.documentElement.style.overflow = '';
        if (lastFocus) lastFocus.focus();
      }
      function openVideo(card) {
        var tpl = card.querySelector('template[data-mnr-video-src]');
        if (!tpl || !tpl.innerHTML.trim()) return;
        if (modal.parentNode !== document.body) document.body.appendChild(modal);
        lastFocus = card;
        vbody.innerHTML = tpl.innerHTML;
        modal.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        var v = vbody.querySelector('video');
        if (v) {
          v.setAttribute('playsinline', '');
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        }
        modal.querySelector('[data-mnr-vclose]').focus();
      }
      root.querySelectorAll('[data-mnr-video]').forEach(function (card) {
        card.addEventListener('click', function () { openVideo(card); });
      });
      modal.addEventListener('click', function (e) {
        if (e.target === modal || e.target.closest('[data-mnr-vclose]')) closeVideo();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !modal.hidden) closeVideo();
      });
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-mnr-offer]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var tier = e.target.closest && e.target.closest('[data-mnr-tier]');
    if (tier) tier.click();
  });
})();
